"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesModule = void 0;
const router_1 = require("client/components/router");
const sites_detail_1 = require("./modules/sites-detail");
const sites_import_1 = require("./modules/sites-import");
const sites_import_map_header_1 = require("./modules/sites-import-map-header");
const sites_import_preview_1 = require("./modules/sites-import-preview");
const sites_import_select_header_1 = require("./modules/sites-import-select-header");
const sites_list_1 = require("./modules/sites-list");
class SitesModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("list", /^\/pharmacies\/?$/, sites_list_1.SitesList);
        this.addRoute("detail", /^\/pharmacies\/(\d+)/, sites_detail_1.SitesDetail);
        this.addRoute("import", /^\/pharmacies\/import?$/, sites_import_1.SitesImport);
        this.addRoute("import", /^\/pharmacies\/import\/select/, sites_import_select_header_1.SitesImportSelectHeader);
        this.addRoute("import", /^\/pharmacies\/import\/map/, sites_import_map_header_1.SitesImportMapHeader);
        this.addRoute("import", /^\/pharmacies\/import\/preview/, sites_import_preview_1.SitesImportPreview);
    }
}
exports.SitesModule = SitesModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/sites.tsx
// module id = 4003
// module chunks = 0